export default __webpack_public_path__ + "static/media/why-1.96a58fbb.PNG";